import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { MdCancel } from "react-icons/md";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import * as CONST from "../Constants";

const propTypes = {
  flash: PropTypes.object.isRequired,
  showButton: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
};
Flash.prototype = propTypes;
export default function Flash(props) {
  let buttonText = CONST.FLASH.CLICK_TO_FINISH;
  if (props.showButton) {
    return (
      <Snackbar
        open
        sx={{ borderRadius: "8px" }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        {props.flash.success && (
          <Alert severity={"success"}>
            <Box mb={2}>{props.flash.success}</Box>
            <Button color="inherit" size="small" onClick={(e) => props.handleClose()}>
              {buttonText}
            </Button>
          </Alert>
        )}
      </Snackbar>
    );
  } else {
    return (
      <Snackbar
        open
        sx={{ borderRadius: "8px" }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={props.flash.success ? "success" : "error"}
          action={
            <button className="close-icon" onClick={(e) => props.handleClose()}>
              <MdCancel />
            </button>
          }
        >
          <div style={{ fontSize: '16px' }} dangerouslySetInnerHTML={{__html: props.flash.success ? props.flash.success : props.flash.error}} />
        </Alert>
      </Snackbar>
    );
  }
}
